/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NqlQueryParamsDTO } from './NqlQueryParamsDTO';
import {
    NqlQueryParamsDTOFromJSON,
    NqlQueryParamsDTOFromJSONTyped,
    NqlQueryParamsDTOToJSON,
} from './NqlQueryParamsDTO';

/**
 * 
 * @export
 * @interface SearchLeaderboardParamsDTO
 */
export interface SearchLeaderboardParamsDTO {
    /**
     * 
     * @type {NqlQueryParamsDTO}
     * @memberof SearchLeaderboardParamsDTO
     */
    query?: NqlQueryParamsDTO;
}

/**
 * Check if a given object implements the SearchLeaderboardParamsDTO interface.
 */
export function instanceOfSearchLeaderboardParamsDTO(value: object): value is SearchLeaderboardParamsDTO {
    return true;
}

export function SearchLeaderboardParamsDTOFromJSON(json: any): SearchLeaderboardParamsDTO {
    return SearchLeaderboardParamsDTOFromJSONTyped(json, false);
}

export function SearchLeaderboardParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLeaderboardParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : NqlQueryParamsDTOFromJSON(json['query']),
    };
}

export function SearchLeaderboardParamsDTOToJSON(value?: SearchLeaderboardParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': NqlQueryParamsDTOToJSON(value['query']),
    };
}

